export const listAiSkillsPractice = {
  eventName: 'skillsPracticeList'
}
